import { z } from 'zod';
import { govmapGroupsSchema } from './govmap-group';

export const actionTemplateBasicDataSchema = z.object({
  title: z.string(),
  description: z.string().nullable(),
  ownerId: z.string().nullable(),
  approverId: z.string().nullable(),
  dueDate: z.number().int().gte(0).nullable(),
  sequence: z.number().nullable(),
});
export const actionTemplateSchema = actionTemplateBasicDataSchema.extend({
  govmapGroups: z.array(z.string()),
});

export const actionTemplateWithGovmapSchema =
  actionTemplateBasicDataSchema.extend({
    govmapGroups: govmapGroupsSchema,
  });

export const actionTemplateBasicDatabaseSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  owner_id: z.string().nullable(),
  approver_id: z.string().nullable(),
  due_date: z.number().int().gte(0).nullable(),
  sequence: z.number().nullable(),
});

export const actionTemplateWithGovmapDatabaseSchema =
  actionTemplateBasicDatabaseSchema
    .extend({
      govmapGroups: govmapGroupsSchema,
    })
    .transform((data) => ({
      id: data.id,
      title: data.title,
      description: data.description,
      ownerId: data.owner_id,
      approverId: data.approver_id,
      dueDate: data.due_date,
      govmapGroups: data.govmapGroups,
      sequence: data.sequence,
    }));

export const actionTemplateDatabaseSchema =
  actionTemplateBasicDatabaseSchema.transform((data) => ({
    id: data.id,
    title: data.title,
    description: data.description,
    ownerId: data.owner_id,
    approverId: data.approver_id,
    dueDate: data.due_date,
    sequence: data.sequence,
  }));

export type ActionTemplate = z.infer<typeof actionTemplateSchema>;
export type ActionTemplateWithGovmap = z.infer<
  typeof actionTemplateWithGovmapSchema
>;
export type ActionTemplateEntity = z.infer<typeof actionTemplateDatabaseSchema>;
export type ActionTemplateWithGovmapEntity = z.infer<
  typeof actionTemplateWithGovmapDatabaseSchema
>;
